export default __webpack_public_path__ + "img/3dadf96475903319555c84bb0a8b9e27.svg";